<template>
  <!-- Recuadro del encargo online al final de las páginas de Notarios y Equipo, ref: https://trello.com/c/ViGfmaUp -->
  <v-container v-if="mostrar" class="acceso-pagina-wrap">
    <div class="acceso-pagina">
      <div class="acceso-pagina__cuerpo">
        <p class="acceso-pagina__titulo">{{ t('Prepare su trámite online') }}</p>
        <p class="acceso-pagina__texto">{{ t('Envíenos sus datos y la documentación por internet y le contactaremos para prepararlo.') }}</p>
      </div>
      <NuxtLink class="acceso-pagina__boton" :to="acceso.enlace(origen)">
        {{ t('Hacerlo online') }}
      </NuxtLink>
    </div>
  </v-container>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useAccesoSolicitud } from '../../composables/solicitudAcceso'
import { t } from '../../composables/solicitudTextos'

const props = defineProps<{ origen: string }>()
const acceso = useAccesoSolicitud()
const mostrar = computed(() => acceso.visible('equipo'))
</script>

<style lang="scss">
.acceso-pagina-wrap { padding-top: 24px; padding-bottom: 56px; }
.acceso-pagina {
  display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 16px;
  padding: 24px 28px; border-radius: 14px; background: #f5f7f9; border: 1px solid #e3e7ea;
  &__cuerpo { flex: 1 1 360px; min-width: 0; }
  &__titulo { font-size: 1.15rem; font-weight: 600; margin: 0 0 4px; color: #1d2329; }
  &__texto { margin: 0; color: #5f6b76; }
  &__boton {
    display: inline-flex; align-items: center; min-height: 48px; padding: 0 26px; border-radius: 999px;
    background: rgb(var(--v-theme-primary)); color: rgb(var(--v-theme-on-primary)) !important;
    font-weight: 600; text-decoration: none !important; white-space: nowrap;
    &:hover, &:focus-visible { filter: brightness(1.08); }
  }
}
</style>
